import Header from "./Header"
import Header2 from "./Header2"

import Buy from "./Buy"
import BookingForm from "./BookingForm"
import TicketOptions from "./TicketOptions"
import Payment from "./Payment"
import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from './providers/Websocket'
import ScrollToTop from './providers/ScrollToTop'



import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'

function App() {
  return (
    <div       style={{ backgroundImage: "url('/bg.png')" }} className="App  ">
  
         

<Router>
    <ScrollToTop />
      <WebSocket />
  <Routes>

      <Route path='/' element={<>
      
          
    <Header/>
         <Buy/>
          <BookingForm/>
      
      </>}/>
      <Route path='/payment' element={<>
   <Header2/>
      <Payment/>
      
      </>}/>
      	{ThreeDSRoutes()}
      </Routes>
      </Router>


    </div>
  );
}

export default App;
